import React, { useEffect, useState } from "react";

const QuestionSingleChoice = ({
	question,
	defaultValue,
	onAnswer,
	handleNext,
}) => {
	const [selectedOption, setSelectedOption] = useState(null);
	const [showResult, setShowResult] = useState(false);
	const [showOptions, setShowOptions] = useState(true);
	const [buttonWidth, setButtonWidth] = useState("w-full"); // Default to full width

	useEffect(() => {
		setShowResult(false);
		setSelectedOption(null);
		setShowOptions(true);

		// Determine max button width based on longest label
		if (question.options.length > 0) {
			const longestLabel = Math.max(
				...question.options.map((opt) => opt.label.length)
			);
			if (longestLabel > 15) setButtonWidth("w-48"); // Large labels
			else if (longestLabel > 10) setButtonWidth("w-36"); // Medium labels
			else setButtonWidth("w-28"); // Small labels
		}
	}, [question]);

	const submitAnswer = () => {
		if (selectedOption !== null) {
			onAnswer(selectedOption);
			setShowResult(true);
		}
	};

	return (
		<div>
			<div className="flex flex-col items-center w-full h-full min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
				{showResult ? (
					<div className={`py-2 px-4 text-center text-md text-gray-700`}>
						<p>
							La bonne réponse est... :{" "}
							{question.options.find((opt) => opt.isCorrect)?.label}
						</p>
						<p
							className={
								selectedOption ===
								question.options.find((opt) => opt.isCorrect)?.value
									? "text-green-600 font-bold"
									: "text-red-600 font-bold"
							}
						>
							{selectedOption ===
							question.options.find((opt) => opt.isCorrect)?.value
								? "Félicitations !"
								: "Dommage !"}
						</p>
						<p className="mt-2 ">{question.explanation}</p>
					</div>
				) : (
					<>
						<h3 className="mb-4 px-2 text-center text-md font-bold text-gray-700">
							{question.text}
						</h3>

						{showOptions && (
							<div className="flex flex-col gap-4 w-full items-center">
								{question.options.map((option, index) => (
									<button
										key={index}
										onClick={() => setSelectedOption(option.value)}
										className={`${buttonWidth} min-w-28 text-sm text-gray-700 text-center py-2 px-4 border rounded-3xl transition-all duration-150 active:translate-y-1
                            ${
															selectedOption === option.value
																? "border-black text-black bg-[#ffc97d] shadow-[6px_6px_0px_rgba(0,0,0,0.7)]"
																: "border-gray-300 text-gray-700 bg-white shadow-[6px_6px_0px_rgba(0,0,0,0.5)]"
														}
                          `}
									>
										{option.label}
									</button>
								))}
							</div>
						)}
					</>
				)}
			</div>
			<div className="mt-4 h-24 px-4 flex w-full justify-end items-center gap-0">
				{showResult ? (
					<button
						onClick={handleNext}
						className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
					>
						Continuer
					</button>
				) : (
					<button
						onClick={submitAnswer}
						className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
					>
						Continuer
					</button>
				)}
			</div>
		</div>
	);
};

export default QuestionSingleChoice;
